import dayjs from "dayjs"
export const clearFilterData = {
  CusId: null,
  BNNo: "",
  BNDteSt:null,
  BNDteEn:null
}
export const initFilterData = {
  ...clearFilterData,
  BNDteSt: dayjs().format("YYYY-MM-DD 00:00:00.000"),
  BNDteEn: dayjs().format("YYYY-MM-DD 23:59:59.997")
}


export const initDialogData = {
  BNId: null,
  BNNo: "",
  BNDte: null,
  RecvPayDte: null,
  BillNm: "",
  BillAddr: "",
  BillTaxId: "",
  Rmk: "",
  Lang: "TH", 
}

export const initSearchInv = {
  InvDteSt: null,
  InvDteEn: null,
  CusId: null,
}
